var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-10"},[_c('Header',{ref:"header"}),_c('Status',{attrs:{"status":_vm.status}}),_c('hospital-list',{model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }